<div *ngFor="let arrayEl of arrayInput; let i = index">
  <span class="font-regular">{{ getElementToShow(arrayEl, i) }} </span>
</div>
<div *ngIf="getMoreElementToDisplayCondition()" class="font-regular light">
  {{ getLabel() }}
</div>
